import React from "react";
import CaseCard from "../../../Home/Sections/Work/Components/CaseCard.js";
import { useNavigate } from "react-router-dom";

const WorkInitialSection = () => {
  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/case-study/${id}`);
  };

  const workList = [
    {
      id: 1,
      title: "Generative AI for Enterprise Software",
      tag: "Generative AI",
      description:
        "Transforming Onboarding and Workflow Creation for Fortune 100 Customers",
      imageURL: "/images/case-studies/1/case-image-0.jpeg",
    },
    {
      id: 2,
      title: "Compliant and Actionable AI",
      tag: "Generative AI",
      description:
        "For Explainability, Transparency & Alignment with the EU AI Act",
      imageURL: "/images/case-studies/2/case-image-0.png",
    },
    {
      id: 3,
      title: "Building a Hybrid AI Center of Excellence",
      tag: "AI center of excellence",
      description:
        "Empowering the organization to scale AI innovation and adoption",
      imageURL: "/images/case-studies/3/case-image-0.jpeg",
    },
    {
      id: 4,
      title: "Predictive Meets Generative",
      tag: "Advanced Analytics and machine learning",
      description: "Revolutionizing Quote-to-Cash for Operational Excellence",
      imageURL: "/images/case-studies/4/case-image-0.jpeg",
    },
    {
      id: 5,
      title: "Empowering Dungeon Masters",
      tag: "Generative AI",
      description:
        "Gen AI-Driven Multimodal Real Time Content for Tabletop Gaming",
      imageURL: "/images/case-studies/5/case-image-0.jpeg",
    },
    {
      id: 6,
      title: "Blending AI and Human Creativity",
      tag: "Generative AI",
      description: "Multimodal Content Engine for Travel Tech Innovation",
      imageURL: "/images/case-studies/6/case-image-0.jpeg",
    },
    {
      id: 7,
      title: "Streamlining Healthcare",
      tag: "Generative AI",
      description: "Agentic Workflows and Gen AI for Smarter Patient Care",
      imageURL: "/images/case-studies/7/case-image-4.jpeg",
    },
    {
      id: 8,
      title: "AI-Driven Health Tech Hub",
      tag: "Generative AI",
      description: "From Smarter Patient Care to Scalable Digital Solutions",
      imageURL: "/images/case-studies/8/case-image-0.jpeg",
    },
    {
      id: 9,
      title: "Future-Proofing with AI",
      tag: "AI strategy and foundation",
      description:
        "Building Scalable Strategies for Next Gen AI Ready Logistics Software Products",
      imageURL: "/images/case-studies/9/case-image-0.jpeg",
    },
  ];

  const shouldSpan = (position) => {
    return (
      position % 8 === 1 ||
      position % 8 === 4 ||
      position % 8 === 5 ||
      position % 8 === 0
    );
  };

  return (
    <section className="relative mb-12">
      <div className="flex flex-col min-h-screen">
        <div className="text-white flex-1 flex flex-col">
          <main className="flex-1 flex flex-col items-center pt-[16%] md:pt-[6%] mx-[6%] md:mx-[24%] z-10 pb-[6%]">
            <h1 className="text-4xl md:text-7xl font-extrabold text-center text-white leading-[140%] tracking-[0] mb-6">
              Turning Challenges into AI Driven Success
            </h1>

            <p className="text-center text-lg md:text-xl font-medium leading-[140%] tracking-[0] text-white mb-12">
              Explore how AI solves challenges, optimizes operations, and drives
              success.
            </p>
          </main>
          <div class="justify-center grid md:grid-cols-3 gap-6 md:gap-4 px-4 md:px-20 pb-12">
            {workList.map((work, index) => {
              const position = index + 1; // 1-based position
              return (
                <CaseCard
                  onClick={work.id ? () => handleClick(work.id) : undefined}
                  tag={work.tag}
                  title={work.title}
                  className={`${shouldSpan(position) ? "md:col-span-2" : ""}`}
                  imageUrl={work.imageURL}
                  description={work.description}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkInitialSection;
